module.exports = __webpack_public_path__ + "img/people.fa2d0980.svg";